/** Flag levé par le service de notifications. */
export enum ENotificationFlag {
	/** Flag levé lorsque le service de notifications est initialisé. */
	Initialized = "initialized"
}